'use client';

import Script from 'next/script';
import type React from 'react';
import { useEffect } from 'react';
import { useNonce } from '@/contexts/NonceContext';

interface GoogleAdProps {
  classNames?: string;
  slot: string;
  timeout?: number;
  googleAdId: string;
  style?: React.CSSProperties;
  format?: string;
  fullWidthResponsive?: boolean;
}

export default function GoogleAd({
  classNames,
  slot,
  timeout = 200,
  googleAdId,
  style,
  format = `auto`,
  fullWidthResponsive = true,
}: GoogleAdProps) {
  const { nonce } = useNonce();

  // ✅ Inicializa o Google Ads depois que o script é carregado
  useEffect(() => {
    const timer = setTimeout(() => {
      if (typeof window !== `undefined` && (window as any).adsbygoogle) {
        (window as any).adsbygoogle.push({});
      }
    }, timeout);
    return () => clearTimeout(timer);
  }, [timeout]);

  return (
    <>
      <Script
        id="google-ads"
        async
        strategy="afterInteractive"
        data-ad-client="ca-pub-9646893046773308"
        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"
        nonce={nonce}
      />

      <div className={classNames || ``}>
        <ins
          className="adsbygoogle"
          style={style || { display: `block`, textAlign: `center` }}
          data-ad-client={googleAdId}
          data-ad-slot={slot}
          data-ad-format={format}
          data-full-width-responsive={fullWidthResponsive ? `true` : `false`}
        />
      </div>
    </>
  );
}
